module.exports = __webpack_public_path__ + "images/7d15dbf9ce149919958df298bad56c25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/components/QuoteSidebar/img/cc2.jpg
// module id = 1381
// module chunks = 0